import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creation: {
    components: [],
    images: [],
    originalData: null,
  },
  update: {
    components: [],
    images: [],
    hasChanges: false,
  },
  display: {
    components: [],
    images: [],
    loading: false,
    error: null,
  },
};

const componentSlice = createSlice({
  name: "components",
  initialState,
  reducers: {
    // Creation actions - Pages
    updateCreationComponent: (state, action) => {
      state.creation.components = action.payload;
    },
    addCreationComponent: (state, action) => {
      state.creation.components.push(action.payload);
    },
    removeCreationComponent: (state, action) => {
      state.creation.components = state.creation.components.filter(
        (p) => p.id !== action.payload,
      );
    },
    // Creation actions - Images
    updateCreationImages: (state, action) => {
      state.creation.images = action.payload;
    },
    addCreationImage: (state, action) => {
      state.creation.images.push(action.payload);
    },
    removeCreationImage: (state, action) => {
      state.creation.images = state.creation.images.filter(
        (img) => img.id !== action.payload,
      );
    },

    resetCreation: (state) => {
      state.creation = initialState.creation;
    },
    loadCreationData: (state, action) => {
      state.creation.components = action.payload.components || [];
      state.creation.images = action.payload.images || [];
    },
    setCreationOriginalData: (state, action) => {
      state.creation.originalData = action.payload;
    },

    // Update actions - Pages
    updateUpdateComponents: (state, action) => {
      state.update.components = action.payload;
      state.update.hasChanges = true;
    },
    addUpdateComponent: (state, action) => {
      state.update.components.push(action.payload);
      state.update.hasChanges = true;
    },
    removeUpdateComponent: (state, action) => {
      state.update.components = state.update.components.filter(
        (p) => p.id !== action.payload,
      );
      state.update.hasChanges = true;
    },

    loadUpdateData: (state, action) => {
      state.update.components = action.payload.components || [];
      state.update.images = action.payload.images || [];
      state.update.hasChanges = false;
    },
    clearUpdateChanges: (state) => {
      state.update.hasChanges = false;
    },
    resetUpdate: (state) => {
      state.update = initialState.update;
    },

    // Display actions
    setDisplayData: (state, action) => {
      state.display.components = action.payload.components || [];
      state.display.images = action.payload.images || [];
      state.display.loading = false;
      state.display.error = null;
    },
    setDisplayLoading: (state, action) => {
      state.display.loading = action.payload;
    },
    setDisplayError: (state, action) => {
      state.display.error = action.payload;
      state.display.loading = false;
    },
    resetDisplay: (state) => {
      state.display = initialState.display;
    },
  },
});

export const {
  updateCreationComponent,
  addCreationComponent,
  removeCreationComponent,
  updateCreationImages,
  addCreationImage,
  removeCreationImage,
  resetCreation,
  loadCreationData,
  setCreationOriginalData,
  updateUpdateComponents,
  addUpdateComponent,
  removeUpdateComponent,
  loadUpdateData,
  clearUpdateChanges,
  resetUpdate,
  setDisplayData,
  setDisplayLoading,
  resetDisplay,
} = componentSlice.actions;

export default componentSlice.reducer;
